import React from 'react';
import { tailwindOverride } from '@getsynapse/design-system';
import { Icon } from '@getsynapse/design-system';
import { TrendData } from './types';
import { formatNumberAbbreviated } from '../../utils/formatters';

const AggregatedTrend: React.FC<TrendData> = ({
  value,
  trend,
  trendIsPercent,
  description,
}) => {
  return (
    <div className='flex items-center gap-x-2 pb-1'>
      <strong
        className='font-bold text-2xl cursor-help'
        title={value.toLocaleString()}
      >
        {formatNumberAbbreviated(value)}
      </strong>
      <small
        style={{ fontSize: '12px' }}
        className={tailwindOverride('text-sm font-bold whitespace-nowrap', {
          'text-error': trend <= 0,
          'text-teal-green': trend > 0,
        })}
      >
        <span className='text-xs'>
          {trend > 0 ? <Icon name='caret-up' /> : <Icon name='caret-down' />}
        </span>
        {Intl.NumberFormat('en-US', {
          style: trendIsPercent ? 'percent' : 'decimal',
          minimumFractionDigits: 0,
          maximumFractionDigits: 2,
        }).format(Math.abs((trend || 0) / (trendIsPercent ? 100 : 1)))}
      </small>
      <div className='overflow-ellipsis'>{description}</div>
    </div>
  );
};

export default AggregatedTrend;
